/**
 * AUTH PROVIDER (Private Routes)
 * ==============================
 * 
 * Protects routes that require authentication.
 * Includes session management for auto-logout/extend.
 */

import { useEffect, useRef } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { getToken, getLoginType, clearAuth, isTokenExpired } from "./Api";
import SessionProvider from "./SessionProvider";
// import { SessionProvider } from "./SessionProvider";

// ============================================
// PRIVATE ROUTES COMPONENT
// ============================================
const PrivateRoutes = () => {
  const location = useLocation();
  const hasValidated = useRef(false);

  const token = getToken();
  const loginType = getLoginType();

  // Validate token on mount (local check only — no server round-trip needed
  // because every API request already verifies the token via the request
  // interceptor in Api.js).
  useEffect(() => {
    if (!token || hasValidated.current) return;
    hasValidated.current = true;

    if (isTokenExpired(token)) {
      console.log("[Auth] Token expired on mount, redirecting...");
      clearAuth();
      window.location.href = "/";
    }
  }, [token]);

  // No token - redirect to login
  if (!token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Wrong login type - redirect
  if (loginType === "admin") {
    return <Navigate to="/a/adminDash" replace />;
  }

  // Wrap with SessionProvider for session management
  return (
    <SessionProvider>
      <Outlet />
    </SessionProvider>
  );
};

export default PrivateRoutes;

// Re-export helpers for convenience
export { getToken, getLoginType, clearAuth } from "./Api";